<template>
  <content-layout>
    <template #header>
      Home
    </template>
    <template #description>
      Search for a location by its reference in the bar at the top, or start from here.
    </template>

    <div class="dashboard-actions">
      <dashboard-action icon="plus" @click="openNewLocationPrompt">New location</dashboard-action>
      <dashboard-action icon="house" @click="$router.push('/pending-locations')">Pending locations</dashboard-action>
      <dashboard-action icon="price-tag" @click="$router.push('/attributes')">Tags/Attributes</dashboard-action>
      <dashboard-action icon="notebook-2" @click="$router.push('/information')">The guide</dashboard-action>
    </div>
  </content-layout>
</template>

<script>
    import auth from '../mixins/auth';
    import newLocation from '../mixins/newLocation';
    import DashboardAction from "../components/dashboard-action";

    export default {
      name: "Home",
      components: {DashboardAction},
      mixins: [auth, newLocation]
    }
</script>

<style scoped>
  .dashboard-actions {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    gap: 16px;
    max-width: 960px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/home.vue